import React from 'react';
import { stackItems } from '../data/content';
export function StackSection() {
  return <section id="stack" aria-labelledby="stack-title" className="border-b border-white/5 bg-ink-900" data-id="element-423" data-mp="jdhd3qnwfqqr">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-424" data-mp="5e88zpcywn35">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-425" data-mp="abrlajq3upsg">
          Integrations
        </p>
        <h2 id="stack-title" className="mt-5 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-426" data-mp="y2x334flvs5e">
          Works with your stack.
        </h2>

        <ul className="mt-10 flex flex-wrap gap-3" data-id="element-427" data-mp="obj736mv5ah0">
          {stackItems.map(item => <li key={item} className="rounded-lg border border-white/10 bg-ink-800 px-4 py-2.5 text-sm font-medium text-white/75" data-id="element-428" data-mp="t9ufdcxifcx4">
              {item}
            </li>)}
        </ul>

        <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/60" data-id="element-429" data-mp="1lt9j72l08v72">
          Your CRM stays. We sit in front of it and write everything back into it.
        </p>
      </div>
    </section>;
}